import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import RwdBasketActions from 'actions/RwdBasketActions/RwdBasketActions';
import store from 'store/Store';
import anaConsts from 'analytics/constants';
import debounceUtils from 'utils/Debounce';
import helpersUtils from 'utils/Helpers';
import CheckoutButtonEN from 'components/RwdBasket/RwdBasketLayout/CostSummary/Buttons/locales/CheckoutButton_en_US';
import CheckoutButtonFR from 'components/RwdBasket/RwdBasketLayout/CostSummary/Buttons/locales/CheckoutButton_fr_CA';

import processEvent from 'analytics/processEvent';
import clickCheckout from 'analytics/bindings/pages/basket/clickCheckout';

const { deferTaskExecution } = helpersUtils;

const { initiateCheckout, openCheckoutInEligibleModal } = RwdBasketActions;
const { dispatch } = store;

function CheckoutButton({
    isBopis, isCheckoutDisabled, isSignedIn, hasSDDItem, isRougeRewardsApplied, ...props
}) {
    const overwriteButtonSize = {
        paddingLeft: 0,
        paddingRight: 0,
        borderWidth: 0
    };

    const getText = localeUtils.getLocalisedDataFromResource(CheckoutButtonEN, CheckoutButtonFR);

    const standardCheckoutClicked = () => {
        if (isSignedIn) {
            processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                data: {
                    bindingMethods: [clickCheckout],
                    previousPageName: digitalData.page.attributes?.previousPageData?.pageName,
                    pageDetail: digitalData.page.pageInfo.pageName,
                    pageName: digitalData.page.attributes?.sephoraPageInfo?.pageName
                }
            });
        }
    };

    // 3 sec debounce to minimize dupe clicks within reason for slow connections
    const handleClick = debounceUtils.preventDoubleClick(() => {
        deferTaskExecution(() => {
            if (hasSDDItem && isRougeRewardsApplied) {
                dispatch(
                    openCheckoutInEligibleModal({
                        title: getText('rewardWarning'),
                        message: getText('checkoutIneligibleForSdd'),
                        buttonText: getText('gotIt')
                    })
                );
            } else if (!isCheckoutDisabled) {
                standardCheckoutClicked();
                dispatch(initiateCheckout(isBopis));
            }
        });
    }, 3000);

    return (
        <Button
            {...props}
            padding={0}
            variant='special'
            disabled={isCheckoutDisabled}
            data-at={Sephora.debug.dataAt('basket_checkout_btn')}
            onClick={handleClick}
            css={overwriteButtonSize}
            children={getText('checkout')}
        />
    );
}

export default wrapFunctionalComponent(CheckoutButton, 'CheckoutButton');
